export default {
	// api请求地址
	baseUrl: 'https://shop.cisa110.com/',
	
	// 图片域名
	imgDomain: 'https://shop.cisa110.com/',
	
	// 前端域名
	webDomain: 'https://shop.cisa110.com/web/',
	
	// 腾讯地图key
	mpKey: '{{$mpKey}}',
	
	// 客服
	webSocket: '{{$webSocket}}',
	
	//本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
	pingInterval: 1500
}